import script from "./applyNow.vue?vue&type=script&setup=true&lang=js"
export * from "./applyNow.vue?vue&type=script&setup=true&lang=js"

import "./applyNow.vue?vue&type=style&index=0&id=494c511c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-494c511c"]])

export default __exports__